import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Divider,
  Grid,
  makeStyles,
  Typography,
  Link,
  colors
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: 20
  }
}));

const DetailsText = ({ title, type }) => (
  <>
    <Typography style={{ color: colors.grey[500] }} variant="h6">
      {title}
    </Typography>
    <Typography>{type}</Typography>
  </>
);
const VehicleDetails = ({ className, vehicle, ...rest }) => {
  const { make, model, color, licensePlate, type, year, imageUrls } = vehicle;
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Card>
        <Divider />
        <CardContent>
          {vehicle.id ? (
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <DetailsText title="Car Make" type={make} />
              </Grid>
              <Grid item md={6} xs={12}>
                <DetailsText title="Car Model" type={model} />
              </Grid>
              <Grid item md={6} xs={12}>
                <DetailsText title="Car Color" type={color} />
              </Grid>
              <Grid item md={6} xs={12}>
                <DetailsText title="Car Plate Number" type={licensePlate} />
              </Grid>
              <Grid item md={6} xs={12}>
                <DetailsText title="Car Type" type={type} />
              </Grid>
              <Grid item md={6} xs={12}>
                <DetailsText title="Car Year" type={year} />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography variant="h6">Car Image</Typography>
                <Typography>
                  {imageUrls[0] ? (
                    <Link href={imageUrls[0]} target="_blank" rel="noopener">
                      View Car Image
                    </Link>
                  ) : (
                    'Not car image uploaded yet'
                  )}
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <Grid>
              <Typography>No car details yet</Typography>
            </Grid>
          )}
        </CardContent>
        <Divider />
      </Card>
    </div>
  );
};

VehicleDetails.propTypes = {
  className: PropTypes.string,
  vehicle: PropTypes.object
};
DetailsText.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string
};

export default VehicleDetails;
